import { PlusOutlined } from '@ant-design/icons';
import { Button, Form } from 'antd';
import React from 'react';

interface FormListAddButtonProps {
    id?: string;
    text: string;
    isDetailMode: boolean;
    add: any;
}

const FormListAddButton: React.FC<FormListAddButtonProps> = ({
    id,
    isDetailMode,
    add,
    text,
}: FormListAddButtonProps) => (
    <>
        {!isDetailMode && (
            <Form.Item className="form-list-add-btn">
                <Button id={id} type="dashed" onClick={(): void => add()} block icon={<PlusOutlined />}>
                    {text}
                </Button>
            </Form.Item>
        )}
    </>
);

export default FormListAddButton;
